module.exports = __webpack_public_path__ + "static/media/secrets.40b54257.png";